import ShoppingList from "./components/ShoppingList"
import Navbar from "./components/Navbar"
import Login from "./components/Login"
import React from "react"
import MealList from "./components/MealList"
import Plan from "./components/Plan"
import StockList from "./components/StockList"
import {getDataFromServer} from "./service"

export default function App({listFromServer}){


  const [loggedIn,setLoggedIn] = React.useState(listFromServer.loggedIn) 

  
  const shopping = loggedIn ? listFromServer.shopping.shopping : []
  const meals    = loggedIn ? listFromServer.meals.meals : []
  // the active dinner plan, or null when there is none yet (superseded plans
  // stay in history server-side and are not returned)
  const plan     = loggedIn && listFromServer.plan ? listFromServer.plan.plan : null

  const [mode,setMode] = React.useState(0)
  const modeOptions = ["Shopping List","Meals","Plan","Stock"]
  const [shoppingList,setShoppingListState] = React.useState(shopping)
  const [mealList,setMealListState] = React.useState(meals)
  const [planState,setPlanState] = React.useState(plan)

  function handleNavigate(modeNumber){
    setMode(modeNumber)
  }

  // re-sync all the local state from the server. Needed after actions that
  // change server-derived state in bulk (Finish plan de-scopes every meal -
  // the shopping list and the Stock view would go stale otherwise).
  // On failure (401 / network) the current state is left untouched.
  async function refreshFromServer(){
    const data = await getDataFromServer()
    if(data && data.loggedIn){
      setShoppingListState(data.shopping.shopping)
      setMealListState(data.meals.meals)
      setPlanState(data.plan ? data.plan.plan : null)
    }
  }

  return(
    <div className="index">
      {loggedIn && <div className="app">
        <Navbar modeName={modeOptions[mode]} handleNavigate={handleNavigate}/>
        {mode === 0 && <ShoppingList 
          listFromServer        = {shoppingList}
          mealsFromServer       = {mealList}
          updateShoppingList    = {setShoppingListState}
          updateMealsFromServer = {setMealListState}
          plan                  = {planState}
        />}
        {mode === 1 && <MealList  
          mealsFromServer   = {mealList}
          updateMeals       = {setMealListState}
        />}
        {mode === 2 && <Plan
          plan            = {planState}
          mealsFromServer = {mealList}
          updatePlan      = {setPlanState}
          refreshFromServer = {refreshFromServer}
        />}
        {mode === 3 && <StockList  
          listFromServer        = {shoppingList}
          mealsFromServer       = {mealList}
          updateShoppingList    = {setShoppingListState}
          updateMealsFromServer = {setMealListState}
        />}
      </div>}
      {!loggedIn && <div className="app">
          <Login/>
      </div>}
    </div>
  )
}